"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
require("core-js/modules/es.reflect.construct.js");
require("core-js/modules/es.symbol.to-primitive.js");
require("core-js/modules/es.date.to-primitive.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DynamicCheckbox = void 0;
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.object.get-prototype-of.js");
var _react = _interopRequireDefault(require("react"));
var _lodash = _interopRequireDefault(require("lodash"));
var _DeprecatedDynamicComponent = _interopRequireDefault(require("../../go/components/dynamic/DeprecatedDynamicComponent"));
var _FormControls = require("../../go/components/common/FormControls");
var _FemaGoModal = _interopRequireDefault(require("../../go/components/common/modal/FemaGoModal"));
var _utils = require("../../common/utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var DynamicCheckbox = /*#__PURE__*/function (_DynamicComponent) {
  _inherits(DynamicCheckbox, _DynamicComponent);
  var _super = _createSuper(DynamicCheckbox);
  function DynamicCheckbox(props) {
    var _this;
    _classCallCheck(this, DynamicCheckbox);
    _this = _super.call(this, props);
    _this.setValue = function (value) {
      var _this$setState;
      return _this.setState((_this$setState = {}, _defineProperty(_this$setState, _this.props.pathToBeUsed, value), _defineProperty(_this$setState, "showConfirmationModal", false), _this$setState), _this.handleBlur);
    };
    _this.handleChange = function (label, value) {
      var confirmModal = _this.props.confirmModal;
      if (confirmModal && confirmModal.onCheck && value || confirmModal && confirmModal.onUncheck && !value) {
        _this.setState({
          showConfirmationModal: true,
          valueToSet: value
        });
      } else {
        _this.setValue(value);
      }
    };
    _this.handleBlur = function () {
      var entityType = _this.props.entityType;
      if (_this.props.entityDataPath !== undefined) {
        _this.props.saveEntityData(_this.props.entityDataPath, entityType, _this.state[_this.props.pathToBeUsed], _this.props.validationId || _this.props.entityDataPath);
      } else {
        _this.save();
        _this.validateField(_this.props.dataPath);
      }
    };
    _this.render = function () {
      var _this$props = _this.props,
        title = _this$props.title,
        pathToBeUsed = _this$props.pathToBeUsed,
        confirmModal = _this$props.confirmModal,
        isHidden = _this$props.isHidden,
        validationDirtyMap = _this$props.validationDirtyMap,
        validationErrors = _this$props.validationErrors,
        hideErrors = _this$props.hideErrors,
        _this$props$disabled = _this$props.disabled,
        disabled = _this$props$disabled === void 0 ? false : _this$props$disabled,
        disableOn = _this$props.disableOn;
      var validationErrorsArray = _lodash.default.isEmpty(validationErrors) || _lodash.default.isArray(validationErrors) ? validationErrors : [validationErrors];
      var firstError = _lodash.default.find(validationErrorsArray, function (err) {
        return !err.isValid;
      }) || false;
      var errorMessage = firstError ? firstError.message : false;
      var displayError = !hideErrors && firstError && validationDirtyMap.dirty;
      var isDisabled = disabled;
      _lodash.default.forEach(disableOn, function (disabledOn) {
        var propValue = _lodash.default.get(_this.props, disabledOn.propsPath);
        isDisabled = disabled || (0, _utils.evaluateOperator)(disabledOn.operator, propValue, disabledOn.value);
      });
      if (isHidden) return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);else return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, confirmModal && /*#__PURE__*/_react.default.createElement(_FemaGoModal.default, {
        title: confirmModal.title,
        type: confirmModal.type,
        open: _this.state.showConfirmationModal,
        confirmAction: function confirmAction() {
          return _this.setValue(_this.state.valueToSet);
        },
        buttonText: confirmModal.action || 'Confirm',
        cancelAction: function cancelAction() {
          return _this.setState({
            showConfirmationModal: false
          });
        }
      }, /*#__PURE__*/_react.default.createElement("p", null, confirmModal.text)), /*#__PURE__*/_react.default.createElement(_FormControls.Checkbox, {
        checked: _this.state[pathToBeUsed],
        label: title,
        disabled: isDisabled,
        handleChange: _this.handleChange,
        handleBlur: _this.handleBlur,
        displayError: displayError,
        errorMessages: errorMessage
      }));
    };
    _this.state = _defineProperty({
      showConfirmationModal: false,
      valueToSet: false
    }, props.pathToBeUsed, props.data);
    return _this;
  }
  _createClass(DynamicCheckbox, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (this.props.resetOnHide && this.props.isHidden) {
        var _this$setState2;
        var dataPath = this.props.dataPath;
        var value = _lodash.default.get(this.props, dataPath);
        this.setState((_this$setState2 = {}, _defineProperty(_this$setState2, this.props.pathToBeUsed, value), _defineProperty(_this$setState2, "showConfirmationModal", false), _this$setState2));
        //this.setValue(!value);
      }

      if (nextProps.isHidden && this.props.data !== undefined) {
        this.setState(_defineProperty({}, nextProps.pathToBeUsed, undefined), this.handleBlur);
      } else {
        this.setState(_defineProperty({}, nextProps.pathToBeUsed, nextProps.data));
      }
    }
  }]);
  return DynamicCheckbox;
}(_DeprecatedDynamicComponent.default);
exports.DynamicCheckbox = DynamicCheckbox;